import { render, staticRenderFns } from "./ElektroView.vue?vue&type=template&id=11b8ad37&"
import script from "./ElektroView.vue?vue&type=script&lang=js&"
export * from "./ElektroView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports